import React, { useState, useEffect } from "react";

import {useStore} from 'react-redux';

import CampanhaService from "../services/CampanhaService";
import RegisterCampaign from "./LoginRegister/RegisterCampaign";
import CustomRegisterCampaign from "./LoginRegister/CustomRegisterCampaign";
import LogosCampanha from "../comps/LogosCampanha/LogosCampanha";
import WeexMessage from "../comps/WeexMessage";

function RegisterSelector(props){
    const i18n = useStore().getState().i18n
    const campanhaService = new CampanhaService();

    const campanhaCorrente = campanhaService.campanhaCorrente();

    const classeDivForm = campanhaCorrente.restrictEligibility ? 'weex_user_container' : '';

    return (
        <div>
            {campanhaCorrente.restrictEligibility ? 
                <LogosCampanha campanha={campanhaCorrente} /> : 
                null
            }

            {campanhaCorrente.restrictEligibility ? 
                <div className="aviso_login">
				<p className="aviso_login_chamada foreground"><WeexMessage code="registro.saudacao" default="Ol&aacute;!"/></p>
				<p className="aviso_login_subtitulo foreground">
					
				</p>
			    </div> :
                null
            }
            
            <div className={`${classeDivForm}`}>
                {campanhaCorrente.tipoInscricao !== 'CUSTOMIZADO' ? (
                    <RegisterCampaign
                        callbackLogin={props.callbackLogin}
                        toggleModo={props.toggleModo}
                        campanha={campanhaCorrente}
                    />
                ) : 
                <CustomRegisterCampaign
                        callbackLogin={props.callbackLogin}
                        toggleModo={props.toggleModo}
                        campanha={campanhaCorrente}
                    />}
            </div>
        </div>
    )
}

export default RegisterSelector;